import Main from './App'
export default Main;


// WEBPACK FOOTER //
// ./src/App/components/App/index.js